import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import formatSiteName from '@utils/formatSiteName';
import getServerSideData from '../../utils/getServerSideData';
import ServerPath from '../../configs/serverPath';
import BrowserUpgrade from '../../components/BrowserUpgrade';

const BrowserUpgradePage = () => {
    const { siteName, composePath, isAutoColorSchemeShow } = useSiteInfo();
    return (
        <>
            <Head>
                <title>{`${formatSiteName(siteName)} | BrowserUpgrade`}</title>
                <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                <link
                    rel="shortcut icon"
                    href={composePath({ pathType: ServerPath.siteImage, pathName: 'favicon.ico' })}
                    type="image/x-icon"
                />

                <link rel="stylesheet" href={composePath({ pathType: ServerPath.globalCss, pathName: 'core.css' })} />
                <link rel="stylesheet" href={composePath({ pathType: ServerPath.siteCss, pathName: 'main.css' })} />
                {isAutoColorSchemeShow && <link
                    rel="stylesheet"
                    href={composePath({ pathType: ServerPath.colorscheme, pathName: 'colorscheme.css' })}
                />}

            </Head>
            <BrowserUpgrade />
        </>
    );
};

export async function getServerSideProps({ req, locale }) {
    const {
        host,
        apiHost,
        serverResponseJson,
        headers,
        ip,
        envConfig,
    } = await getServerSideData({ req });

    return {
        props: {
            ...(await serverSideTranslations(locale, ['common'])),
            ...serverResponseJson,
            host,
            apiHost,
            ip,
            serverResponseJson,
            headers,
            locale,
            envConfig,
        },
    };
}

export default BrowserUpgradePage;
